import React, { useState, useEffect } from "react";
import { Row, Col, Button, Form, Dropdown, ButtonGroup } from "react-bootstrap";
import { GiMoneyStack } from "react-icons/gi";
import { FaTrashAlt } from "react-icons/fa"; // Import delete icon
import "./provident-fund-req.css";
import ProvidentLayout from "../../components/ProvidentLayout.js";

// Number of rows per page
const rowsPerPageOptions = [10, 25, 50, 100];

const ProvidentFundReq = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);
  const [pfRequests, setPfRequests] = useState([]); // State to store PF data
  const [total, setTotal] = useState(0); // Total number of records
  const [error, setError] = useState(""); // To handle errors

  // Fetch data from the API using userID
  useEffect(() => {
    const userId = localStorage.getItem("userId"); // Get userId from localStorage

    if (userId) {
      fetch(`https://backend.ems.uk.hiradentallab.com/api/pf-requests/pf-requests/user/${userId}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`API Error: ${response.statusText}`);
          }
          return response.json();
        })
        .then((data) => {
          // Check if data is an array and update state accordingly
          if (data && Array.isArray(data)) {
            setPfRequests(data);
            setTotal(data.length);
          } else if (data && data.data && Array.isArray(data.data)) {
            setPfRequests(data.data);
            setTotal(data.data.length);
          } else {
            setError("Unexpected API response structure");
          }
        })
        .catch((error) => {
          setError("Failed to fetch data. Please try again later.");
        });
    } else {
      setError("No userID found in localStorage.");
    }
  }, []);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(total / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(value);
    setCurrentPage(1);
  };
  const handleDeleteRequest = (requestId) => {
    if (window.confirm("Are you sure you want to delete this request?")) {
      fetch(`https://backend.ems.uk.hiradentallab.com/api/pf-requests/${requestId}`, {
        method: "DELETE",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to delete the request.");
          }
          return response.json();
        })
        .then((data) => {
          alert(data.message);
          setPfRequests(pfRequests.filter((request) => request.requestId !== requestId));
        })
        .catch((err) => {
          console.error("Delete Error:", err.message);
          alert("Unable to delete PF request. Please try again.");
        });
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(total / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  // Paginated data
  const paginatedData = pfRequests.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <ProvidentLayout>
      <h1 className="provident-fund-req-header">
        <GiMoneyStack className="icon-margin" /> Provident Fund Requests
      </h1>
      <hr />
      <div className="provident-fund-req-container">
        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}

        <div className="entries-search-container" style={{ marginTop: 0 }}>
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary">Show Entries</Button>
                <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                <Dropdown.Menu>
                  {rowsPerPageOptions.map((option, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={() => handleRowsPerPageChange(option)}
                    >
                      {option}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end search-container">
              <Form className="d-flex">
                <Form.Control
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                  className="search-input"
                />
              </Form>
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <table className="table table-striped provident-fund-req-table">
            <thead className="provident-req-table-header">
              <tr>
                <th>SR</th>
                <th>Name</th>
                <th>Amount Requested</th>
                <th>Requested At</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item, index) => {
                  console.log('Item:', item); // Log item to check if is present
                  return (
                    <tr key={item.requestId}>
                      <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                      <td>{item.name || "N/A"}</td>
                      <td>{item.amountRequested}</td>
                      <td>
                        {item.createdAt
                          ? new Date(item.createdAt).toLocaleDateString()
                          : "N/A"}
                      </td>
                      <td>{item.status || "N/A"}</td>
                      <td>
  {item.status === "pending" ? (
    <FaTrashAlt
      style={{ cursor: "pointer", color: "red" }}
      onClick={() => handleDeleteRequest(item.pfId)}  // Pass pfId here
    />
  ) : (
    <FaTrashAlt
      style={{ cursor: "not-allowed", color: "gray" }}
      title="Cannot delete - Status is not 'pending'"
    />
  )}
</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No data Available Now
                  </td>
                </tr>
              )}
            </tbody>

            <tfoot>
              <tr className="provident-req-table-footer">
                <td>Total</td>
                <td>{pfRequests.length}</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
              </tr>
            </tfoot>
          </table>
          <div className="containerrrr">
            <Row className="custom-row">
              <Col xs={12} md={9} className="custom-col-left">
                Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, total)} of {total} Entries
              </Col>
              <Col xs={12} md={3} className="custom-col-right">
                <nav>
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        Previous
                      </button>
                    </li>
                    {pageRange().map((page) => (
                      <li className={`page-item ${currentPage === page ? "active" : ""}`} key={page}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(page)}
                        >
                          {page}
                        </button>
                      </li>
                    ))}
                    <li
                      className={`page-item ${currentPage === Math.ceil(total / rowsPerPage) ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(currentPage + 1)}
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </ProvidentLayout>
  );
};

export default ProvidentFundReq;
